import { render, staticRenderFns } from "./FormatoPedidosModify.vue?vue&type=template&id=e8c6e248&scoped=true"
import script from "./FormatoPedidosModify.vue?vue&type=script&lang=js"
export * from "./FormatoPedidosModify.vue?vue&type=script&lang=js"
import style0 from "./FormatoPedidosModify.vue?vue&type=style&index=0&id=e8c6e248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c6e248",
  null
  
)

export default component.exports